import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import BrandStory from "../components/BrandStory";
import ShopByAge from "../components/ShopByAge";
import PromoBanners from "../components/PromoBanners";
import TopPicks from "../components/TopPicks";
import NewArrivals from "../components/NewArrivals";
import TopBrands from "../components/TopBrands";
import WhyParents from "../components/WhyParents";
import InstagramFeed from "../components/InstagramFeed";
import Footer from "../components/Footer";
import { useStore } from "../context/StoreContext";
import { fetchProducts } from "../api";
import { topPicks as mockTopPicks, newArrivals as mockNewArrivals } from "../mock";

const Home = () => {
  const { wishlist, cart, toggleWishlist, addToCart } = useStore();
  const [topPicks, setTopPicks] = useState([]);
  const [newArrivals, setNewArrivals] = useState([]);

  useEffect(() => {
    fetchProducts({ top_picks: true })
      .then(setTopPicks)
      .catch(() => setTopPicks(mockTopPicks));
    fetchProducts({ new_arrivals: true })
      .then(setNewArrivals)
      .catch(() => setNewArrivals(mockNewArrivals));
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <Header cartCount={cart.length} wishlistCount={wishlist.length} />
      <main>
        <Hero />
        <BrandStory />
        <ShopByAge />
        <PromoBanners />
        <TopPicks products={topPicks} wishlist={wishlist} toggleWishlist={toggleWishlist} addToCart={addToCart} />
        <NewArrivals products={newArrivals} wishlist={wishlist} toggleWishlist={toggleWishlist} addToCart={addToCart} />
        <TopBrands />
        <WhyParents />
        <InstagramFeed />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
